import { createSlice, type PayloadAction, type WithSlice } from '@reduxjs/toolkit';

import {
  rootReducer,
  DATAGRID_INITIAL_PAGE,
  DATAGRID_INITIAL_PAGE_SIZE,
} from '@verantos-dev/core-annotation-tool';

export interface AnnotatorProjectState {
  projectsListPage: number;
  projectsListPageSize: number;
}

const initialState: AnnotatorProjectState = {
  projectsListPage: DATAGRID_INITIAL_PAGE,
  projectsListPageSize: DATAGRID_INITIAL_PAGE_SIZE,
};

const annotatorProjectSlice = createSlice({
  name: 'annotatorProject',
  initialState,
  reducers: {
    setProjectsListPaginationModel: (
      state,
      action: PayloadAction<{ page: number; pageSize: number }>
    ) => {
      state.projectsListPage = action.payload.page;
      state.projectsListPageSize = action.payload.pageSize;
    },
  },
});

export const { setProjectsListPaginationModel } = annotatorProjectSlice.actions;

declare module '@verantos-dev/core-annotation-tool' {
  // WithSlice utility assumes reducer is under slice.reducerPath
  // eslint-disable-next-line @typescript-eslint/no-empty-object-type, @typescript-eslint/no-empty-interface
  export interface LazyLoadedSlices extends WithSlice<typeof annotatorProjectSlice> {}
}

annotatorProjectSlice.injectInto(rootReducer);

export { annotatorProjectSlice };
